module.exports = __webpack_public_path__ + "static/img/ShadedLogo.8e47b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShadedLogo.png
// module id = m5dy
// module chunks = 1